import { ReactCompareSlider } from 'react-compare-slider';

type Props = {
  site: any;
  cta_resumes_before_after: {
    title: string;
    subtitle: string;
    cta: string;
    image: {
      url: string;
      alt: string;
      width: number;
      height: number;
    };
    image_2: {
      url: string;
      alt: string;
      width: number;
      height: number;
    };
  };
};

export default function BeforeAfter({ site, cta_resumes_before_after }: Props) {
  if (!cta_resumes_before_after) {
    return <></>;
  }

  const getImageUrl = (template: string) => {
    return `https://mmc-preview-s3-storage.s3.eu-central-1.amazonaws.com/templates/resumes/${site?.html_lang}/${template}.jpeg`;
  };

  return (
    <ReactCompareSlider
      className="compare-slider"
      itemOne={
        <img
          src={cta_resumes_before_after.image.url}
          alt={cta_resumes_before_after.image.alt}
          width={cta_resumes_before_after.image.width}
          height={cta_resumes_before_after.image.height}
          loading="lazy"
        />
      }
      itemTwo={
        <img
          src={getImageUrl('regulus')}
          alt={cta_resumes_before_after.image_2.alt}
          width={cta_resumes_before_after.image_2.width}
          height={cta_resumes_before_after.image_2.height}
          loading="lazy"
        />
      }
      handle={
        <div className="handle">
          <div className="button">
            <img
              src="/assets/icons/chevron-left-white.svg"
              alt="chevron left"
              className="left"
              width="16"
              height="16"
              loading="lazy"
            />
            <img
              src="/assets/icons/chevron-right-white.svg"
              alt="chevron right"
              className="right"
              width="16"
              height="16"
              loading="lazy"
            />
          </div>
        </div>
      }
    />
  );
}
